import { useFormat } from '@ideavivat/vivat-2';

import {
  type, materialBrand, materialCode, bom_item, purchase_request,
} from './base';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    purchase_request,
    type,
    bom_item,
    _materialControls: {
      name: 'ชิ้นส่วน',
      width: '20rem',
      class: {
        cell: 'has-multiselect',
      },
    },
    // materialCode: {
    //   ...materialCode,
    //   width: '10rem',
    // },
    description: {
      name: 'รายละเอียด',
      width: '1.8fr',
      filter: (val: string, row: any) => row.item.bom_item?.description || '',
    },
    materialBrand,
    neededAmount: {
      name: 'จำนวนที่ต้องการ / ซื้อแล้ว',
      width: '10rem',
      class: 'text-right',
    },
    amount: {
      name: 'จำนวนที่สั่งซื้อ',
      width: '6rem',
      class: 'text-right',
    },
    purchaseUnit: {
      name: 'หน่วยสั่งซื้อ',
      width: '6rem',
      class: 'text-right',
    },
    pricePerUnit: {
      name: 'ราคาต่อหน่วย',
      width: '6rem',
      class: 'text-right',
    },
    amountPerUnit: {
      name: 'จำนวนในกล่อง/แพ็ค',
      width: '8rem',
      class: 'text-right',
    },
    totalPrice: {
      name: 'รวมยอด',
      width: '6rem',
      filter: (val: string, row: any) => parseFloat(`${(row.item.amount || 0) * (row.item.pricePerUnit || 0)}` || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      class: 'text-right',
    },
    totalItems: {
      name: 'จำนวนที่ได้รับ',
      width: '6rem',
      filter: (val: string, row: any) => `${parseFloat(`${row.item.amount * row.item.amountPerUnit}` || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${row.item.material.unit}`,
      class: 'text-right',
    },
    target_date: {
      name: 'วันที่ต้องการ',
      width: '8rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
  },
};
